<template>
    <div>
        <LogoutButton v-if="isAuthenticated" />
        <LoginButton v-else />
    </div>
</template>

<script setup lang="ts">
    import LoginButton from "@/ComponentsChild/LoginButton.vue";
    import LogoutButton from "@/ComponentsChild/LogoutButton.vue";
    import { useAuth0 } from "@/Services/Auth0/auth0-plugin";
    import { computed, watch } from "vue";
    import { useRouter } from 'vue-router';
    import { Auth0 } from '@/Services/Auth0/auth0-interface'
    
    const auth0: Auth0 | null = useAuth0();
    const router = useRouter();

    const isAuthenticated = computed(() => {
        if (!auth0) {
            return null;
        }

        return auth0.isAuthenticated.value;
    });

    // Watch the isAuthenticated property and redirect if it changes to true
    watch(isAuthenticated, (newValue) => {
        if (newValue) {
            router.push({ name: 'home' }); 
        }
    });

</script>
